import { type AppDispatch } from "features/Application/globaltypes/redux";
import {
  errCampaign,
  gotCampaign,
  gotOptions,
  reqCampaign,
  reqOptions,
  setIsLoaded,
} from "../slices/campaignDetailsSlice";
import DataService from "features/Application/services/dataServices/typedDataService";
import { openEntityDetails, setEntityId } from "../slices/campaignEntityStateSlice";
import { type CampaignView } from "../../types/state";
import { PriorityLevels } from "enums";
import { cloneDeep } from "lodash";

export const fetchCampaignOptions = () => async (dispatch: AppDispatch) => {
  dispatch(reqOptions());
  try {
    const campaignTypesOptionsPromise = DataService.threatDefence.campaigns.getCampaignTypes();
    const subdomainsOptionsPromise = DataService.threatDefence.campaigns.getSubdomains();
    const triggerTypesOptionsPromise = DataService.threatDefence.campaigns.getTriggerTypes();

    const [campaignTypesOptions, subdomainsOptions, triggerTypesOptions] = await Promise.all([
      campaignTypesOptionsPromise,
      subdomainsOptionsPromise,
      triggerTypesOptionsPromise,
    ]);
    dispatch(
      gotOptions({
        campaignTypes: campaignTypesOptions.data,
        subdomains: subdomainsOptions.data,
        triggerTypes: triggerTypesOptions.data,
      }),
    );
    dispatch(setIsLoaded(true));
  } catch {}
};

const getWithRemedialTrainingFlow = async (campaign: CampaignView): Promise<CampaignView> => {
  const result = cloneDeep(campaign);
  const flowId = Number(result.remedialTraining?.flowId || 0);
  if (result.remedialTraining && flowId > 0) {
    const notExist = await DataService.flows.flowDetailsNotExist(flowId);
    if (notExist) {
      result.remedialTraining.triggerTypeId = undefined;
      result.remedialTraining.flowId = undefined;
      result.remedialTraining.flowTitle = "";
      result.remedialTraining.priority = PriorityLevels.none;
      result.remedialTraining.dueDate = "";
      result.remedialTraining.daysToComplete = 1;
      return result;
    }

    const flowDetailsData = await DataService.flows.getFlowDetails(flowId);
    result.remedialTraining.flowTitle = flowDetailsData.data.title;
    result.remedialTraining.flowThumbnailUrl = flowDetailsData.data.thumbnailUrl;
  }

  return result;
};

export const getCampaign = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(reqCampaign());
  try {
    const response = await DataService.threatDefence.campaigns.getCampaign(id);
    const campaign = await getWithRemedialTrainingFlow({ ...response.data });

    dispatch(gotCampaign(campaign));
    dispatch(
      openEntityDetails({
        id: campaign.id,
        isDraft: campaign.isDraft,
        dateModified: campaign.dateModified,
      }),
    );
    dispatch(setEntityId(id));
  } catch (error) {
    dispatch(errCampaign(error));
  }
};
